import PropTypes from 'prop-types'
import { forwardRef, memo, useMemo } from 'react'
import { normalizeSizeString } from 'app/util/sizes'
import useFallbackRef from 'lib/react/hooks/useFallbackRef'
import classNames from 'lib/util/classNames'
import lineItemStyles from '../LineItem.module.scss'
import styles from './Subtitle.module.scss'

/**
 * The `Subtitle`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
const Subtitle = forwardRef((props, forwardedRef) => {
  const { children, className, size, wrap, ...rest } = props
  const ref = useFallbackRef(forwardedRef)
  const classNameOutput = useMemo(
    () =>
      classNames([
        className,
        lineItemStyles.subtitle,
        styles.subtitle,
        styles[`size-${normalizeSizeString(size)}`],
        wrap && styles.wrap
      ]),
    [className, size]
  )

  return (
    <h3 ref={ref} className={classNameOutput} {...rest}>
      {children}
    </h3>
  )
})

// Display name
Subtitle.displayName = 'Subtitle'

/** @type {object} */
Subtitle.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  size: PropTypes.string,
  wrap: PropTypes.bool
}

/** @type {object} */
Subtitle.defaultProps = {
  children: null,
  className: '',
  size: 'standard',
  wrap: false
}

// Memoize
export default memo(Subtitle)
